import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BudgetStrip2023 from '../../collection-templates/budget-strip-2023';

const BudgetTopBannerWidget = (props) => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <BudgetStrip2023 widget={true} {...props} />
    </QueryClientProvider>
  );
};

export { BudgetTopBannerWidget };
